
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";

const CallToAction = () => {
  const { t } = useTranslation();

  return (
    <section className="section-padding gradient-bg text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">
            {t("cta.title")}
          </h2>
          <p className="text-base sm:text-lg mb-6 sm:mb-8 opacity-90 px-2">
            {t("cta.subtitle")}
          </p>
          <div className="flex justify-center">
            <Link to="/demo#demo-request-form">
              <Button 
                size="lg" 
                className="w-full sm:w-auto bg-white text-brand-600 hover:bg-gray-100 hover:text-brand-700 font-semibold shadow-md transition-all"
              >
                {t("cta.button")}
              </Button>
            </Link>
          </div>
          <p className="mt-4 sm:mt-6 text-xs sm:text-sm opacity-80">
            {t("cta.trial")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
